import DefaultInstance from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { DefaultApiWorkLogsWorksFindPostRequest, DefaultApiWorkLogsWorksGetRequest, DefaultApiWorkLogsWorksWorkLogIdGetRequest } from "@sizlcorp/sizl-api-document/dist/models";

export const workLogsWokrs = createQueryKeys('workLogsWorks', {
    all: null,
    get: (params: DefaultApiWorkLogsWorksGetRequest) => {
        const query = { ...params };
        if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
            query["query"] = JSON.stringify(params.query);
        }
        if (params.search) {
            query["search"] = params.search;
            query["searchFields"] = params.searchFields;
        }

        return {
            queryKey: [query, JSON.stringify(query.query)],
            queryFn: () => DefaultInstance.workLogsWorksGet(query)
        }
    },
    find: (params: DefaultApiWorkLogsWorksFindPostRequest) => {
        const query = { ...params };
        if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
            query["query"] = JSON.stringify(params.query);
        }
        if (params.search) {
            query["search"] = params.search;
            query["searchFields"] = params.searchFields;
        }

        return {
            queryKey: [query, JSON.stringify(query.query)],
            queryFn: () => DefaultInstance.workLogsWorksFindPost(query)
        }
    },
    detail: (params: DefaultApiWorkLogsWorksWorkLogIdGetRequest) => {
        return {
            queryKey: [params],
            queryFn: () => DefaultInstance.workLogsWorksWorkLogIdGet(params)
        }
    }
});